import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent {
  @Input() items: MenuItem[] = [];
  @Input() displayLogo: boolean = true;

  private readonly defaultLogo = '/assets/img/logo.1643a230.svg';
  private readonly studentLogo = '/assets/img/Recon360_logo.png';

  constructor(private router: Router) {}

  get logoSrc(): string {
    return this.isStudentRoute ? this.studentLogo : this.defaultLogo;
  }

  get logoAlt(): string {
    return this.isStudentRoute ? 'Recon 360' : 'College Recon';
  }

  get logoClass(): string {
    const mdWidth = this.isStudentRoute ? 'md:w-[10.5rem]' : 'md:w-[12.5rem]';
    const mdHeight = this.isStudentRoute ? 'md:h-[4.8rem]' : 'md:h-[4.25rem]';
    return `mr-4 w-[7.5rem] cursor-pointer ${mdHeight} ${mdWidth}`;
  }

  private get isStudentRoute(): boolean {
    return this.router.url.startsWith('/student');
  }
}
